import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import { LinearProgress, Typography } from "@mui/material";
import MobileFooter from 'app/components/MobileFooter/MobileFooter';
import MobileHeader from 'app/components/MobileHeader/MobileHeader';
import MobileButton from 'app/components/MobileButton/MobileButton';
import InputSearch from 'app/components/InputSearch/InputSearch';
import Card from '@mui/material/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Chip from '@mui/material/Chip';
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { requestApi } from 'app/utils/RestApi';
import InfiniteScroll from 'react-infinite-scroll-component';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import Swal from 'sweetalert2';
import { COMMON, DRAFT, REFERRER } from 'app/utils/constants/endPoint';
import { isMobile } from 'react-device-detect';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';


function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			className='tab-ref'
			style={{ overflow: "hidden" }}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box>
					<Div>{children}</Div>
				</Box>
			)}
		</div>
	);
}

CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}


const WebViewHomepageRefealProgram = () => {
	const location = useLocation();
	const [searchParams] = useSearchParams();
	const agentCode = searchParams.get('agentCode')?.trim();

	const [listData, setListData] = React.useState([]);
	const [listDataDraft, setListDataDraft] = React.useState([]);
	const [listDataDraftTmp, setListDataDraftTmp] = React.useState([]);
	const [listDataTmp, setListDataTmp] = React.useState([]);
	const [isLoading, setIsLoading] = React.useState(false);
	const [scrollStatus, setScrollStatus] = React.useState({
		'tab-0': true,
		'tab-1': true
	});
	const [hasMore, setHasMore] = React.useState(true);
	const [params, setParams] = React.useState({
		pageIndex: 0,
		pageSize: 3,
		orderBy: "createdDate",
		orderBehavior: "desc",
		searchValue: "",
		agentCode
	});
	const [paramsDraft, setParamsDraft] = React.useState({
		pageIndex: 0,
		pageSize: 3,
		agentCode
	});

	const [hasNotAgreedToTNC, setHasNotAgreedToTNC] = React.useState(true);

	const [tabValue, setTabValue] = React.useState(0);

	const [draftTabFirstRender, setDraftTabFirstRender] = React.useState(true);
	const [submittedTabFirstRender, setSubmittedTabFirstRender] = React.useState(true);

	React.useEffect(() => {
		// if (!isMobile) {
		// 	Swal.fire({
		// 		icon: 'warning',
		// 		title: 'Forbidden!',
		// 		text: 'Halaman ini tidak dapat diakses melalui browser',
		// 		allowOutsideClick: false,
		// 		showConfirmButton: false
		// 	});
		// } else {

		if (localStorage.getItem('tab') == null) {
			if (params.searchValue !== "") {
				fetchData()
			} else {
				if (listData.length <= 0) {
					fetchData()
				} else {
					setListData(listDataTmp)
				}
			}
		} else {
			checkStorage()
		}
		// }
	}, []);

	function checkStorage() {
		setTabValue(Number(localStorage.getItem('tab')))
		if (Number(localStorage.getItem('tab')) === 0) {
			fetchData()
		} else {
			fetchDraft()
		}
	}

	const handleOnChange = React.useCallback((val) => {
		setParams({
			...params,
			searchValue: val
		})
	}, []);

	const navigate = useNavigate();

	const fetchData = async () => {
		setIsLoading(true)
		await requestApi(REFERRER.INDEX, {
			params
		}).then((res) => {
			setIsLoading(false)
			if (res.data.data) {
				if (params.searchValue !== "") {
					setListData(res.data.data.items)
				} else {
					// Array.prototype.push.apply(newArray, res.data.data.items);
					setListData(res.data.data.items)
					// setListDataTmp(newArray)

				}
				setScrollStatus((prevState) => ({ ...prevState, ['tab-0']: !res.data.data.last }))
			}
		}).catch((err) => {
			setIsLoading(false)
			console.log(err)
		})

		setSubmittedTabFirstRender(false)
	}

	React.useEffect(() => {
		if (agentCode) {
			checkTncStatus()
		}
	}, [agentCode])

	const checkTncStatus = async () => {
		await requestApi(COMMON.TNC_AGENT, {
			subfolder: '/' + agentCode
		}).then(({ data }) => {
			if (data?.status === 'success') {
				setHasNotAgreedToTNC(!data.data.hasAgreeTnc)
			}
		}).catch(err => console.log(err))
	}

	const edit = (referrer) => {
		navigate('/webviewEditReferrer' + location.search, { state: { referrer } });
	}

	const openDetail = (referrer) => {
		navigate('/webViewRefferalDetail', { state: { referrer } });
	}

	const openDetailDraft = (referrer) => {
		navigate('/webViewAddRefferal' + location.search, { state: { referrer } });
	}

	const navigateBack = () => {
		localStorage.removeItem('agentCode')
		localStorage.removeItem('token')
		localStorage.removeItem('tab')
		window.ReactNativeWebView.postMessage(JSON.stringify('exit webview'));
	}

	const navigateAdd = () => {
		navigate('/webViewAddRefferal' + location.search);
	}

	const navigateAddRefTerminated = () => {
		navigate('/webViewReRegis' + location.search);
	}

	const handleChange = (event, newValue) => {
		localStorage.setItem('tab', newValue)
		setTabValue(newValue);
		if (newValue == 1) {
			if (draftTabFirstRender) {
				fetchDraft()
			}
		} else {
			if (submittedTabFirstRender) {
				fetchData()
			}
		}
	};

	const fetchDraft = async () => {
		await requestApi(DRAFT.INDEX, {
			params: paramsDraft
		}).then((res) => {
			setIsLoading(false)
			if (res.data.data) {
				setListDataDraft(res.data.data.items)
				setScrollStatus((prevState) => ({ ...prevState, ['1']: !res.data.data.last }))
			}
		}).catch((err) => {
			setIsLoading(false)
			console.log(err)
		})

		setDraftTabFirstRender(false)

	}

	const openModalDelete = async (referrer) => {
		Swal.fire({
			title: 'Konfirmasi',
			text: 'Apakah Anda yakin ingin menghapus data?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'OK',
			cancelButtonText: 'Batal',
			confirmButtonColor: 'red'
		}).then(async (result) => {
			if (result.isConfirmed) {
				Swal.showLoading()
				await requestApi(DRAFT.DELETE, {
					subfolder: '/' + referrer.id
				}).then((res) => {
					Swal.close();
					setIsLoading(false)
					if (res.data.status == 'success') {
						let listDraftTemp = [...listDataDraft].filter(drf => drf.id != referrer.id)
						setListDataDraft(listDraftTemp)
					}
				}).catch((err) => {
					Swal.close();
					if (err?.data) {
						var arrayError = [];
						for (let [key, value] of Object.entries(err.data)) {
							arrayError.push(value)
						}
						var errorJoin = arrayError.join('<br>');

						Swal.fire({
							icon: 'error',
							text: errorJoin
						});
					} else if (err?.message) {
						Swal.fire({
							icon: 'error',
							text: err.message
						});
					} else {
						Swal.fire({
							icon: 'error',
							text: 'Mohon Coba beberapa saat lagi'
						});
					}
				})
			}
		});
	};

	const onScroll = () => {
		const scrollTop = document.documentElement.scrollTop
		const scrollHeight = document.documentElement.scrollHeight
		const clientHeight = document.documentElement.clientHeight
		if (scrollTop + clientHeight >= scrollHeight) {
			if (tabValue == 0) {
				if (scrollStatus['tab-0']) {
					setParams((prevState) => ({
						...prevState,
						pageSize: prevState.pageSize + 3
					}))
				}
			} else {
				if (scrollStatus['tab-1']) {
					setParamsDraft((prevState) => ({
						...prevState,
						pageSize: prevState.pageSize + 3
					}))
				}

			}
		}
	}
	React.useEffect(() => {
		window.addEventListener('scroll', onScroll)
		return () => window.removeEventListener('scroll', onScroll)
	}, [listData, listDataDraft])

	React.useEffect(() => {
		fetchData()
	}, [params])

	React.useEffect(() => {
		fetchDraft()
	}, [paramsDraft])

	return (
		<Div className='page-wrapper-mobile'>
			<MobileHeader
				backIcon
				headerTx={"Referral Listing"}
				backOnClick={navigateBack}
			/>

			<ContentWrapper isMobile className='page-tab'>
				<Tabs
					value={tabValue}
					onChange={handleChange}
					aria-label="basic tabs example"
					variant="fullWidth"
					textColor="primary"
					indicatorColor="primary"
				>
					<Tab label="Submitted" {...a11yProps(0)} />
					<Tab label="Draft" {...a11yProps(1)} />
				</Tabs>
				<CustomTabPanel value={tabValue} index={0}>
					{
						submittedTabFirstRender ?
							<Div>
								<LinearProgress color="secondary" />
							</Div>
							:
							<Div>
								<Div sx={{
									m: 3,
									mb: 0,
									display: 'flex',
									flexDirection: 'row'
								}}>
									<InputSearch onChange={handleOnChange} />
								</Div>

								<Div id="scrollableDiv" sx={{ height: "100%", overflowY: "scroll" }}>
									{(listData.length > 0 ?
										<InfiniteScroll
											dataLength={listData.length}
											next={(e) => {
												// fetchData()
											}}
											style={{ display: 'flex', flexDirection: 'column-reverse' }}
											scrollableTarget="scrollableDiv"
											hasMore={true}
											// loader={<LinearProgress color="secondary" />}
											endMessage={
												<p style={{ textAlign: 'center' }}>
													{
														listData.length > 4 &&
														<b>no more data..</b>
													}
												</p>
											}
										>
											<Div sx={{ mt: 2 }}>
												{listData.map((row, index) => (
													<Div key={index} sx={{ m: 3, mb: 2 }}>
														<Card variant="outlined" sx={{
															padding: "12px"
														}}>
															<Row className='p-2'>
																<Col>
																	<Typography fontSize={12}>Nama Referrer</Typography>
																</Col>
																<Col>
																	<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.name}</Typography>
																</Col>
															</Row>
															<Row className='p-2'>
																<Col>
																	<Typography fontSize={12}>Kode Referrer</Typography>
																</Col>
																<Col>
																	<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.referrerCode}</Typography>
																</Col>
															</Row>
															<Row className='p-2 bt-4'>
																<Col>
																	<Typography fontSize={12}>No. Telepon</Typography>
																</Col>
																<Col>
																	<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.phoneNumber}</Typography>
																</Col>
															</Row>
															<Row className='p-2'>
																<Col>
																	<Typography fontSize={12}>Email</Typography>
																</Col>
																<Col>
																	<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.email}</Typography>
																</Col>
															</Row>
															<Row className='p-2 bt-4'>
																<Col>
																	<Typography fontSize={12}>Status</Typography>
																</Col>
																<Col className='flex-justify-end'>
																	<Chip
																		label={row.referralStatus === "WAITING_VERIFICATION" ? "WAITING VERIFICATION" : row.referralStatus}
																		size="small"
																		color={row.referralStatus === "TERMINATED" ? "error" : "success"}
																		sx={{ borderRadius: '5px' }}
																	/>
																</Col>
															</Row>
															<Row className='p-2 bt-4'>
																<Col className='flex-justify-start'>
																	<Typography fontSize={12}>Lihat Detail</Typography>
																</Col>
																<Col>
																	<MobileButton
																		sx={{
																			textAlign: 'right'
																		}}
																		size={'small'}
																		preset={"round"}
																		btnText={"Detail"}
																		onClick={() => openDetail(row)}
																	/>
																</Col>
															</Row>
															{
																"WAITING_VERIFICATION" === row.referralStatus &&
																<Row className='p-2 bt-4'>
																	<Col className='flex-justify-start'>
																		<Typography fontSize={12}>Edit</Typography>
																	</Col>
																	<Col>
																		<MobileButton
																			sx={{
																				textAlign: 'right'
																			}}
																			size={'small'}
																			preset={"round"}
																			btnText={"Edit"}
																			onClick={() => edit(row)}
																		/>
																	</Col>
																</Row>
															}
														</Card>
													</Div>
												))}
											</Div>
										</InfiniteScroll>
										:
										<Div sx={{ m: 3 }}>
											<Div sx={{ mb: 2 }}>
												<Card variant="outlined" sx={{
													padding: "12px"
												}}>
													<Div className='dis-flex-center'>
														<img src={`${process.env.REACT_APP_IMAGES_PATH}/ReffKosong.svg`} width={91} height={91} />
													</Div>
													<Typography sx={{ mt: 1 }} fontSize={14} textAlign={"center"} color={"black"}>Anda tidak memiliki Referrer pada saat ini. Silakan klik tombol Tambah Referrer untuk menambahkan Referrer</Typography>
												</Card>
											</Div>
										</Div>
									)}
								</Div>
							</Div>
					}
				</CustomTabPanel>
				<CustomTabPanel value={tabValue} index={1}>
					{
						draftTabFirstRender ?
							<Div>
								<LinearProgress color="secondary" />
							</Div>
							:
							<Div>
								{(listDataDraft.length > 0 ?
									<InfiniteScroll
										dataLength={listDataDraft.length}
										next={fetchDraft}
										hasMore={true}
										endMessage={
											<p style={{ textAlign: 'center' }}>
												{
													listDataDraft.length > 4 &&
													<b>no more data..</b>
												}
											</p>
										}
									>
										<Div sx={{ mt: 1 }}>
											{listDataDraft.map((row, index) => (
												<Div key={index} sx={{ m: 3, mb: 2 }}>
													<Card variant="outlined" sx={{
														padding: "12px"
													}}>
														<Row className='p-2'>
															<Col>
																<Typography fontSize={12}>Nama Referrer</Typography>
															</Col>
															<Col>
																<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.name}</Typography>
															</Col>
														</Row>
														<Row className='p-2 bt-4'>
															<Col>
																<Typography fontSize={12}>No. Telepon</Typography>
															</Col>
															<Col>
																<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.phoneNumber}</Typography>
															</Col>
														</Row>
														<Row className='p-2'>
															<Col>
																<Typography fontSize={12}>Email</Typography>
															</Col>
															<Col>
																<Typography fontSize={12} fontWeight={600} textAlign={"right"}>{row.email}</Typography>
															</Col>
														</Row>
														<Row className='p-2 bt-4'>
															<Col>
																<Typography fontSize={12}>Status</Typography>
															</Col>
															<Col className='flex-justify-end'>
																<Chip
																	label={'NEW'}
																	size="small"
																	color={"success"}
																	sx={{ borderRadius: '5px' }}
																/>
															</Col>
														</Row>
														<Row className='p-2 bt-4'>
															<Col className='flex-justify-start'>
																<Typography fontSize={12}>Lihat Detail</Typography>
															</Col>
															<Col>
																<Div className='flex-justify-end'>
																	<MobileButton
																		sx={{
																			textAlign: 'right'
																		}}
																		size={'small'}
																		preset={"round"}
																		btnText={"Hapus"}
																		onClick={() => openModalDelete(row)}
																	/>
																	<MobileButton
																		sx={{
																			textAlign: 'right', ml: 1
																		}}
																		size={'small'}
																		preset={"secondaryRound"}
																		btnText={"Lanjut"}
																		onClick={() => openDetailDraft(row)}
																	/>
																</Div>
															</Col>
														</Row>
													</Card>
												</Div>
											))}
										</Div>
									</InfiniteScroll>
									:
									<Div sx={{ m: 3 }}>
										<Div sx={{ mb: 2 }}>
											<Card variant="outlined" sx={{
												padding: "12px"
											}}>
												<Div className='dis-flex-center'>
													<img src={`${process.env.REACT_APP_IMAGES_PATH}/ReffKosong.svg`} width={91} height={91} />
												</Div>
												<Typography sx={{ mt: 1 }} fontSize={14} textAlign={"center"} color={"black"}>Anda tidak memiliki Referrer pada saat ini. Silakan klik tombol Tambah Referrer untuk menambahkan Referrer</Typography>
											</Card>
										</Div>
									</Div>
								)}
							</Div>
					}
				</CustomTabPanel>
			</ContentWrapper>

			<MobileFooter>
				<Row className='p-2 bt-4'>
					<Col>
						<ButtonStyled
							disabled={hasNotAgreedToTNC}
							btnText={"Tambah Referrer"}
							preset={"primary"}
							onClick={navigateAdd}
						/>
					</Col>
					<Col>
						<ButtonStyled
							disabled={hasNotAgreedToTNC}
							btnText={"Daftar Ulang"}
							preset={"primary"}
							onClick={navigateAddRefTerminated}
						/>
					</Col>
				</Row>
			</MobileFooter>

		</Div>


	);
};

export default WebViewHomepageRefealProgram;